export enum ReminderChannelEnum {
  Email = 'Email',
  SMS = 'SMS',
  Push = 'Push',
  WhatsApp = 'WhatsApp',
  Call = 'Call',
}
